import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=0e5cdd52&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5cdd52')) {
      api.createRecord('0e5cdd52', component.options)
    } else {
      api.reload('0e5cdd52', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=0e5cdd52&", function () {
      api.rerender('0e5cdd52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6wGS5YGi759/JS/comp/openstreetmap.vue"
export default component.exports